renderArr